import { render, staticRenderFns } from "./Uploadimgbatch.vue?vue&type=template&id=d6c360f6&"
import script from "./Uploadimgbatch.vue?vue&type=script&lang=js&"
export * from "./Uploadimgbatch.vue?vue&type=script&lang=js&"
import style0 from "./Uploadimgbatch.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports